import { render, staticRenderFns } from "./PostFeedbackForm.vue?vue&type=template&id=7833817a&lang=pug"
import script from "./PostFeedbackForm.vue?vue&type=script&lang=js"
export * from "./PostFeedbackForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports